   


import React, { useState, useEffect, useRef } from "react";
import { format } from "date-fns";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Stack,
} from "@mui/material";
import axios from "axios";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import Header from "../Components/Header";
import EmployeeSideBar from "../Components/EmployeeSideBar";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import { Link } from "react-router-dom";
import TextField from "@mui/material/TextField";
// import { DownloadTableExcel } from 'react-export-table-to-excel';
import * as XLSX from "xlsx"; // Import XLSX library for Excel file generation

function EmployeeTable() {
  const [salesData, setSalesData] = useState([]);
  const elementRef = useRef(null);
  const [arrowDisable, setArrowDisable] = useState(true);
  const [filteredSalesData, setFilteredSalesData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [userData, setUserData] = useState({});
  // const tableRef = useRef(null);


    // Function to handle exporting table data to Excel
    const handleExportExcel = () => {
      const ws = XLSX.utils.json_to_sheet(filteredSalesData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "sales_data.xlsx");
    };  

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling behavior
    });
  };

  const handleHorizantalScroll = (element, speed, distance, step) => {
    let scrollAmount = 0;
    const slideTimer = setInterval(() => {
      element.scrollLeft += step;
      scrollAmount += Math.abs(step);
      if (scrollAmount >= distance) {
        clearInterval(slideTimer);
      }
      if (element.scrollLeft === 0) {
        setArrowDisable(true);
      } else {
        setArrowDisable(false);
      }
    }, speed);
  };

  useEffect(() => {
    axios
      .get("http://localhost:5002/fetchdsr")
      .then((res) => setSalesData(res.data));
  }, []);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#eb922c",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#d5a2673d",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));



  useEffect(() => {
    axios.get("http://localhost:5002/fetchdsr").then((res) => {
      setSalesData(res.data);
      setFilteredSalesData(res.data); //  filtered data with all sales data
    });
  }, []);



  useEffect(() => {
    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserData(userData);
      setSearchQuery(userData.username);
    }
  }, []);

  useEffect(() => {
    // Filter sales data based on search query
    if (searchQuery.trim() === "") {
      setFilteredSalesData(salesData); // Reset to show all data if search query is empty
    } else {
      const filteredData = salesData.filter((row) =>
        row.sales_team.toString().includes(searchQuery.trim())
      );
      setFilteredSalesData(filteredData);
    }
  }, [searchQuery, salesData]);

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const title = "DSR Table";



  return (
    <div className="background">
      <Header title={title} />

      <div style={{ display: "flex", flexDirection: "row" }}>
            <EmployeeSideBar/>

        <Container
          className="table-container"
          sx={{ margin: 0, padding: 0, maxWidth: "100%" }}
        >
          <div id="main">
            {/* <Typography variant="h4" align="center" gutterBottom>
              Sales Data
            </Typography> */}
            <div className="Search">
              <Stack spacing={4}>
                <Stack spacing={5} direction={"row"}>
                  <TextField
                    style={{ width: "224px", display: 'none'  }}
                    label="Search by DSR ID"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                  />

          <Button variant="contained" onClick={handleExportExcel}>
              Export Excel
            </Button>

                  <Button variant="contained"
                    style={{
                      color: "white",
                      textDecoration: "none",
                      fontWeight: "bold",
                    }}
                    component={Link} to="/EmployeeDsr"
                  >
                    {" "}
                    Add{" "}
                  </Button>
                </Stack>
              </Stack>
            </div>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <Button
                variant="outlined"
                sx={{ margin: "10px 10px 10px 10px" }}
                onClick={() => {
                  handleHorizantalScroll(elementRef.current, 20, 305, -10);
                }}
                disabled={arrowDisable}
              >
                <FaArrowLeft />
              </Button>
              <Button
                sx={{ margin: "10px 10px 10px 0px" }}
                variant="outlined"
                onClick={() => {
                  handleHorizantalScroll(elementRef.current, 20, 305, 10);
                }}
              >
                <FaArrowRight />
              </Button>
            </div>

            <TableContainer component={Paper} ref={elementRef}>
              <Table>
                <TableHead
                  sx={{
                    ".MuiTableCell-root": { fontWeight: "600" },
                  }}
                >
                  <TableRow>
                    <StyledTableCell>S.NO</StyledTableCell>
                    <StyledTableCell>Register_Date</StyledTableCell>
                    <StyledTableCell>Time</StyledTableCell>
                    <StyledTableCell>Sales Team</StyledTableCell>
                    <StyledTableCell>Company_Name</StyledTableCell>
                    <StyledTableCell>Company_Address</StyledTableCell>
                    <StyledTableCell>Company_Phone</StyledTableCell>
                    <StyledTableCell>Lead_Status</StyledTableCell>
                    <StyledTableCell>Follow_Up_Date</StyledTableCell>
                    <StyledTableCell>FeedBack</StyledTableCell>
                    <StyledTableCell>Products_Pitched</StyledTableCell>
                    <StyledTableCell>Products_Sold</StyledTableCell>
                    <StyledTableCell>Price_Quoted</StyledTableCell>
                    <StyledTableCell>Sale Type</StyledTableCell>
                    <StyledTableCell>Sale_Amount</StyledTableCell>
                    <StyledTableCell>GST</StyledTableCell>
                    <StyledTableCell>Total Amount</StyledTableCell>
                    <StyledTableCell>Contract_Signed_Date</StyledTableCell>
                    <StyledTableCell>Client_Name</StyledTableCell>
                    <StyledTableCell>Client_Phone_Number</StyledTableCell>
                    <StyledTableCell>Client_Email</StyledTableCell>
                    <StyledTableCell>ADV/BAL Amount</StyledTableCell>
                    <StyledTableCell>Clearance Amount</StyledTableCell>
                    <StyledTableCell>Balance Amount</StyledTableCell>
                    <StyledTableCell>remaining</StyledTableCell>
                    <StyledTableCell>balance amount1</StyledTableCell>
                    <StyledTableCell>net amount</StyledTableCell>
                    <StyledTableCell>balance amount2</StyledTableCell>
                    <StyledTableCell>payment mode</StyledTableCell>
                    <StyledTableCell>Notes</StyledTableCell>
                    <StyledTableCell>Action</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredSalesData.map((row) => (
                    <StyledTableRow key={row.dsr_id}>
                      <StyledTableCell>{row.dsr_id}</StyledTableCell>
                      <StyledTableCell>
                        {format(new Date(row.date), "dd-MM-yyyy")}
                      </StyledTableCell>
                      <StyledTableCell>{row.time}</StyledTableCell>
                      <StyledTableCell>{row.sales_team}</StyledTableCell>
                      <StyledTableCell>{row.company_name}</StyledTableCell>
                      <StyledTableCell>{row.company_address}</StyledTableCell>
                      <StyledTableCell>{row.company_phone}</StyledTableCell>
                      <StyledTableCell>{row.lead_status}</StyledTableCell>
                      <StyledTableCell>
                        {format(new Date(row.follow_up_date), "dd-MM-yyyy")}
                      </StyledTableCell>

                      <StyledTableCell>{row.feedback}</StyledTableCell>

                      <StyledTableCell>{row.products_pitched}</StyledTableCell>
                      <StyledTableCell>{row.products_sold}</StyledTableCell>
                      <StyledTableCell>{row.price_quoted}</StyledTableCell>

                      <StyledTableCell>{row.sales_type}</StyledTableCell>
                      <StyledTableCell>{row.sale_amount}</StyledTableCell>
                      <StyledTableCell>{row.gst}</StyledTableCell>
                      <StyledTableCell>{row.total_amount}</StyledTableCell>
                      <StyledTableCell>
                        {format(
                          new Date(row.contract_signed_date),
                          "dd-MM-yyyy"
                        )}
                      </StyledTableCell>
                      <StyledTableCell>{row.client_name}</StyledTableCell>
                      <StyledTableCell>
                        {row.client_phone_number}
                      </StyledTableCell>
                      <StyledTableCell>{row.client_email}</StyledTableCell>
                      <StyledTableCell>{row.adv_bal_amount}</StyledTableCell>
                      <StyledTableCell>{row.clearance_amount}</StyledTableCell>
                      <StyledTableCell>{row.balance_amount}</StyledTableCell>
                      <StyledTableCell>{row.remaining}</StyledTableCell>
                      <StyledTableCell>{row.balance_amount1}</StyledTableCell>
                      <StyledTableCell>{row.net_amount}</StyledTableCell>
                      <StyledTableCell>{row.balance_amount2}</StyledTableCell>
                      <StyledTableCell>{row.payment_mode}</StyledTableCell>
                      <StyledTableCell>{row.notes}</StyledTableCell>

                      <StyledTableCell>
                        <button>
                          <Link to={`/DsrUpdate/${row.dsr_id}`}>
                            {" "}
                            <EditCalendarIcon />
                          </Link>
                        </button>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <Button
            variant="contained"
            color="primary"
            onClick={handleScrollToTop}
          >
            Scroll To Top
          </Button>
        </Container>
      </div>
    </div>
  );
}

export default EmployeeTable;
